<mat-chip
  [color]="matChipColor"
  [attr.color]="matChipColor"
  [removable]="false"
  [class.chip-muted]="isMuted"
  data-balance-summary-chip
>{{ labelKey | translate }}</mat-chip>
